<!--
 * @Author: 
 * @Date: 
 * @LastEditors: 
 * @LastEditTime: 
 * @Description: file content
 -->
<template>
  <div class="ranking">
    <div class="logo">
      <img
        :src="imgHost + 'logo.png'"
      />
    </div>
    <div class="index_title">
      <img
        :src="imgHost + 'slogan.png?v=1'"
      />
    </div>
    <div class="ranking-box">
      <div class="title-bg">给力好友</div>
      <div class="ranking-list">
        <div class="list-item" v-for="(item, index) in rankingList" :key="index" >
          <div class="rank">{{ index + 1 }}</div>
          <div class="head-img">
            <img :src="item.headImg" alt="">
          </div>
          <div class="name">{{item.nickName}}已成功为你助力 </div>
        </div>
        <div class="no-data" v-if="rankingList.length === 0">暂无好友助力~<br/>现在参与活动<br/>iPhone 12、小米液晶电视机等<br/>超多好礼等你来抢！</div>
      </div>
    </div>
    <BaseBtnHome></BaseBtnHome>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {},
  data() {
    return {
      rankingList: [],
      myRank: {},
      myIndex: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    async getRankingList() {
      const data = await this.$httpdf.get(this.apiHost + 'assistance/myFriends')
      if (data.code == 0) {
        this.rankingList = data.data.filter((v)=> v!=null)
      }
    }
  },
  mounted() {
    this.getRankingList();
  },
};
</script>
<style lang="scss" scoped>
.ranking {
  position: absolute;
  background: #A10632 url( $imgHost + 'bg.jpg?t=5') 0 0 / 100% no-repeat;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
}
.ranking-circular {
  position: absolute;
  width: 150%;
  height: 152px;
  left: -25%;
  top: 0;
  border-radius: 0 0 50% 50% ;
  background: linear-gradient(180deg, #00C2FD, #00CDC6);
  box-shadow: 0px 2px 4px 0px rgba(0, 199, 226, 0.35);
}
.no-data {
  text-align: center;
  font-size: 15px;
  color: #fff;
  margin-top: 30%;
  line-height: 150%;
}
.top-three {
  margin-top: 40px;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 60px;
  height: 152px;
  .item {
    font-size: 12px;
    font-family: PingFangSC;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    .head-img {
      background: #fff;
      width: 68px;
      height: 68px;
      border-radius: 50%;
      margin: 0 auto;
      position: relative;
      img {
        position: relative;
        z-index: 2;
        border-radius: 50%;
        box-sizing: border-box;
        height: 100%;
        background: #fff;
      }
      &::after {
        content: '';
        position: absolute;
        z-index: 1;
        top: -25px;
        left: 50%;
        transform: translateX(-50%);
        width: 42px;
        height: 32px;
      }
    }
    &:nth-child(1) {
      margin-top: 10px;
      .head-img {
        img {
          border: 2px solid #DCDCDC;
        }
        &::after {
          background: url($imgHost + 'bird/rank2.png') center / 100% no-repeat;
        }
      }
    }
    &:nth-child(2) {
      margin-top: -20px;
      .head-img {
        width: 78px;
        height: 78px;
        img {
          border: 3px solid #FFD850;
        }
        &::after {
          top: -30px;
          width: 50px;
          height: 38px;
          background: url($imgHost + 'bird/rank1.png') center / 100% no-repeat;
        }
      }
    }
    &:nth-child(3) {
      margin-top: 10px;
      .head-img {
        img {
          border: 2px solid #FFB155;
        }
        &::after {
          background: url($imgHost + 'bird/rank3.png') center / 100% no-repeat;
        }
      }
    }
    .name {
      max-width: 80px;
      margin-top: 4px; 
    }
    .score {
      margin-top: 6px; 
    }
  }
}
.ranking-list {
  padding: 20px 10px;
  height: calc(100vh - 250px);
  box-sizing: border-box;
  overflow: auto;
  position: relative;
  z-index: 2;
  .list-item {
    display: flex;
    align-items: center;
    font-size: 15px;
    font-family: PingFangSC;
    font-weight: 400;
    color: #fff;
    height: 43px;
    .rank {
      width: 30px;
      font-size: 18px;
      font-family: PingFangSC;
      font-weight: 500;
      color: #fff;
      text-align: center;
    }
    .head-img {
      background: #fff;
      width: 34px;
      height: 34px;
      border-radius: 50%;
      margin: 0 auto;
      position: relative;
      img {
        border-radius: 50%;
      }
    }
    .name {
      flex: 1;
      margin-left: 25px;
      span {
        font-size: 10px;
        opacity: 0.74;
      }
    }
    .score {
      margin-right: 25px; 
    }
    &.my-rank {
      .name {
        font-weight: 500;
      }
      .score {
        background: linear-gradient(0deg, #00C2FD 0.4150390625%, #00CDC6 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
}
.ranking-box {
  margin: 0 auto;
  width: 340px;
  border: 1px solid #FEFAD3;
  border-radius: 5px;
  position: relative;
  .title-bg {
    width: 240px;
    height: 34px;
    line-height: 34px;
    background: linear-gradient(90deg, #FEFED9 0%, #DBB682 100%);
    border-radius: 11px;
    position: absolute;
    top: -17px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    font-size: 18px;
    font-family: PingFangSC;
    font-weight: bold;
    color: #C40027;
    &::after,&::before {
      content: '';
      display: block;
      width: 12px;
      height: 12px;
      background: #C40027;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      right: 22px;
      transform: translateY(-50%);
    }
    &::before {
      left: 22px;
      right: auto;
    }
  }
}
.logo {
  width: 100%;
  margin: 10px 0 0 15px;
}

.logo>img {
  width: 352px;
  height: auto;
}
.index_title {
  width: 304px;
  margin-top: 11px;
  margin: 0 auto;
}
</style>